/**
 * @returns {Boolean} - A boolean value current environment is the MyWM app.
 */
// eslint-disable-next-line func-names
export const isMyWMApp = (function () {
  return process.env.REACT_APP_MYWM_APP === "true"
})()
